module.exports = __webpack_public_path__ + "static/media/README.5a35e7f4.md";